var _path, _g, _path2, _path3, _g2, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "63457-ai 1",
    clipPath: "url(#clip0_955_31929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    d: "M23.9082 11.9988C23.9082 18.5733 18.5736 23.8965 11.9992 23.8965C5.42479 23.8965 0.101562 18.5733 0.101562 11.9988C0.101562 5.42444 5.42479 0.0898438 11.9992 0.0898438C18.5736 0.0898438 23.9082 5.42444 23.9082 11.9988Z",
    fill: "#E31837"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_955_31929",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cp7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.9087 11.9954C23.9087 18.5698 18.5786 23.8999 12.0042 23.8999C5.42868 23.8999 0.0986328 18.5698 0.0986328 11.9954C0.0986328 5.41989 5.42868 0.0898438 12.0042 0.0898438C18.5786 0.0898438 23.9087 5.41989 23.9087 11.9954Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_955_31929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>_2",
    d: "M14.2291 18.3602H9.66797V15.2891H14.2291V18.3602Z",
    fill: "#FABB9F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Path>_3",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7713 17.5071C11.4538 17.7801 12.2158 17.9393 12.9552 17.9507C13.376 17.9507 13.8083 17.9052 14.2291 17.8256V15.2891H9.66797V16.8701C9.98645 17.1545 10.3959 17.3592 10.7713 17.5071Z",
    fill: "#E6E7E8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_4",
    d: "M16.9817 9.58973C16.9931 9.48736 17.1865 9.30537 17.2775 9.23713C17.4595 9.10063 17.6528 9.2485 17.7097 9.41912C17.7666 9.57836 17.7666 9.76035 17.7779 9.93097C17.8121 10.3291 17.7438 10.7272 17.5618 11.0912C17.4367 11.33 17.232 11.5234 17.0045 11.6826C17.0045 11.6826 16.7542 11.7964 16.7087 11.5234C16.7087 11.5234 16.9817 9.60111 16.9817 9.58973Z",
    fill: "#FABB9F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_5",
    d: "M16.9363 9.83936C16.9477 9.75974 17.0842 9.62325 17.1524 9.57775C17.2889 9.48675 17.4254 9.58912 17.4595 9.71424C17.4936 9.82799 17.505 9.9531 17.5164 10.0782C17.5278 10.3626 17.4823 10.6469 17.3571 10.9086C17.2661 11.0792 17.1183 11.2157 16.959 11.3294C16.959 11.3294 16.777 11.409 16.7429 11.2157L16.9363 9.83936Z",
    fill: "#DCA58E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_6",
    d: "M6.80156 9.58973C6.77881 9.48736 6.58545 9.30537 6.50583 9.23713C6.31246 9.10063 6.1191 9.2485 6.06222 9.41912C6.01673 9.57836 6.00535 9.76035 5.99398 9.93097C5.97123 10.3291 6.0281 10.7272 6.22147 11.0912C6.34658 11.33 6.53995 11.5234 6.76744 11.6826C6.76744 11.6826 7.01768 11.7964 7.07455 11.5234C7.07455 11.5234 6.80156 9.60111 6.80156 9.58973Z",
    fill: "#FABB9F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_7",
    d: "M6.83603 9.83936C6.82465 9.75974 6.68816 9.62325 6.63129 9.57775C6.49479 9.48675 6.34693 9.58912 6.3128 9.71424C6.27868 9.82799 6.2673 9.9531 6.2673 10.0782C6.24456 10.3626 6.29005 10.6469 6.42655 10.9086C6.50617 11.0792 6.65404 11.2157 6.81328 11.3294C6.81328 11.3294 6.99527 11.409 7.02939 11.2157L6.83603 9.83936Z",
    fill: "#DCA58E"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>_8",
    d: "M17.1297 9.95378C17.1297 11.2277 16.9022 12.513 16.288 13.6163C15.742 14.5718 14.9344 15.3452 14.0586 15.9595C13.3534 16.4599 12.5913 17.04 11.7041 16.9718C10.7714 16.8922 10.0434 16.1301 9.36094 15.5272C8.40549 14.6855 7.64341 13.6277 7.18843 12.3993C6.8927 11.6372 6.76758 10.7727 6.76758 9.95378C6.76758 5.84762 9.08796 3.26562 11.9429 3.26562C14.8093 3.26562 17.1297 5.84762 17.1297 9.95378Z",
    fill: "#FFEACC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>_9",
    d: "M19.905 19.7479L14.2292 18.2578H11.9429H9.66804L3.98084 19.7479C3.98084 19.7479 1.35335 20.7147 1.05762 23.8085H11.9429H22.8282C22.5439 20.7147 19.905 19.7479 19.905 19.7479Z",
    fill: "#FABB9F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>_10",
    d: "M19.905 19.7479L14.2292 18.2578H11.9429H9.66804L3.98084 19.7479C3.98084 19.7479 1.35335 20.7147 1.05762 23.8085H11.9429H22.8282C22.5439 20.7147 19.905 19.7479 19.905 19.7479Z",
    fill: "#FEFEFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>_11",
    d: "M19.905 19.7475L15.6965 18.6442L11.9429 23.8082L8.23487 18.6328L3.98084 19.7475C3.98084 19.7475 1.35335 20.7143 1.05762 23.8082H11.9429H22.8282C22.5439 20.7143 19.905 19.7475 19.905 19.7475Z",
    fill: "#002A41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>_12",
    d: "M11.4429 21.2266L10.3965 23.8086H13.3766L12.3529 21.2266H11.4429Z",
    fill: "#FBAF3F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>_4"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>_13",
    d: "M11.8748 18.3125L10.5439 20.0983L11.4653 21.2243H11.9202L12.3752 21.213L13.2624 20.0528L11.8748 18.3125Z",
    fill: "#FBAF3F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Path>_14",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.762 19.8576C12.5913 20.1988 12.2842 20.5742 11.852 20.4832C11.4084 20.3922 11.2037 19.9713 11.306 19.5391C11.4084 19.1182 11.67 18.777 11.8179 18.3789L10.5439 20.0964L11.4653 21.2225L12.3752 21.2111L13.2624 20.0509L12.8871 19.5732C12.8567 19.6718 12.815 19.7666 12.762 19.8576Z",
    fill: "#D1D2D3"
  })))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>_15",
    d: "M6.77928 9.4524C6.77928 9.4524 7.54136 4.82302 9.90724 5.27799C9.90724 5.27799 12.057 6.6088 13.8428 5.24387C13.8428 5.24387 16.0153 5.17562 17.1982 9.4524C17.1982 9.4524 17.5053 4.89126 14.2295 3.26472C14.2295 3.26472 11.1925 1.86567 8.59918 3.94719C8.59918 3.94719 6.14231 5.88083 6.77928 9.4524Z",
    fill: "#3B2313"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>_16",
    d: "M11.943 23.8082L8.23498 18.6328L5.25488 19.4063L9.05393 22.0793L8.07574 22.5115L9.83877 23.8082H11.943Z",
    fill: "#001A35"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>_17",
    d: "M11.9434 23.816L15.6628 18.6406L18.6315 19.4141L14.8325 22.0871L15.8107 22.5193L14.059 23.816H11.9434Z",
    fill: "#001A35"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>_18",
    d: "M7.42773 18.3707L9.65712 17.3242L11.932 18.2683L14.2069 17.3242L16.5841 18.3707L13.2173 20.6228L11.932 18.7801L10.5443 20.6228L7.42773 18.3707Z",
    fill: "#E1E2E3"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_955_31929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.9c73feec877236da13906fef6e6b074e.svg";
export { ForwardRef as ReactComponent };